import { render, staticRenderFns } from "./fileCard.vue?vue&type=template&id=1f1bf082&scoped=true"
import script from "./fileCard.vue?vue&type=script&lang=js"
export * from "./fileCard.vue?vue&type=script&lang=js"
import style0 from "./fileCard.vue?vue&type=style&index=0&id=1f1bf082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1bf082",
  null
  
)

export default component.exports